<template>
  <scroller
    :on-refresh="refresh"
  >
    <NavButtonBar>
      <nav-button @action="$router.back()">
        <i class="fa-solid fa-angle-left" />
      </nav-button>
    </NavButtonBar>
    <h1 class="text-primary pb-50 mt-2">
      {{ $t('pages.expedition_sheets.now.name') }}
    </h1>
    <h4> 📋 {{ $t('pages.expedition_sheets.name') }}</h4>

    <div class="pt-75 mb-3">
      <template v-if="error">
        <div
          class="mb-5 text-muted text-center d-flex flex-column px-3"
        >
          <h1 class="mt-3 mb-2">
            <i class="fa-regular fa-cloud-exclamation" />
          </h1>
          {{ $t('pages.expedition_sheets.now.loading-error') }}

          <div>
            <TouchButton
              size="xs"
              class="mt-2"
              @action="refresh(() => {}, true)"
            >
              {{ $t('therms.retry') }}
            </TouchButton>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="!isFetch">
          <div class="d-flex align-items-center justify-content-center my-5 py-2">
            <b-spinner
              variant="primary"
              style="width: 3rem; height: 3rem;"
            />
          </div>
        </template>
        <template v-else>
          <template
            v-if="has"
          >
            <p class="text-black-25 mt-0 mb-3 pb-50">
              {{
                lastPullFormat !== null ? $t('pages.expedition_sheets.now.updated-at', { date: lastPullFormat }) : $t('therms.loading')
              }}
            </p>

            <!--            <div class="mb-2">-->
            <!--              <div class="mb-2 mt-2 d-flex align-items-center justify-content-between">-->
            <!--                <div class="d-flex align-items-center">-->
            <!--                  <touch-icon-button @action="displayOptions = !displayOptions">-->
            <!--                    <i-->
            <!--                      v-if="!displayOptions"-->
            <!--                      :disabled="loader|| !isFetch"-->
            <!--                      class="fa-solid fa-gear"-->
            <!--                    />-->
            <!--                    <i-->
            <!--                      v-else-->
            <!--                      class="fa-regular fa-gear"-->
            <!--                    />-->
            <!--                  </touch-icon-button>-->
            <!--                  <div-->
            <!--                    v-if="!displayOptions"-->
            <!--                    :disabled="loader|| !isFetch"-->
            <!--                    class="ml-1"-->
            <!--                  >-->
            <!--                    {{ $t('therms.display-options') }}-->
            <!--                  </div>-->
            <!--                  <div-->
            <!--                    v-else-->
            <!--                    class="ml-1"-->
            <!--                  >-->
            <!--                    {{ $t('therms.hide-options') }}-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                <transition name="fade">-->
            <!--                  <touch-icon-button-->
            <!--                    v-if="displayOptions"-->
            <!--                    :disabled="loader|| !isFetch"-->
            <!--                    @action="displayFilters = !displayFilters"-->
            <!--                  >-->
            <!--                    <i-->
            <!--                      v-if="!displayFilters"-->
            <!--                      style="font-size: 0.9em"-->
            <!--                      class="fa-solid fa-filter"-->
            <!--                    />-->
            <!--                    <i-->
            <!--                      v-else-->
            <!--                      style="font-size: 0.9em"-->
            <!--                      class="fa-solid fa-filter-slash"-->
            <!--                    />-->
            <!--                  </touch-icon-button>-->
            <!--                </transition>-->
            <!--              </div>-->

            <!--              <transition name="scale-in">-->
            <!--                <div v-show="displayOptions">-->

            <!--                  <transition name="scale-in">-->
            <!--                    <div v-if="displayFilters">-->
            <!--                      <b-card class="mb-1">-->
            <!--                        <b-row>-->
            <!--                          <b-col>-->
            <!--                            <b-card-text class="mb-50">-->
            <!--                              {{ $t('therms.filter-list-by') }} :-->
            <!--                            </b-card-text>-->
            <!--                          </b-col>-->
            <!--                        </b-row>-->
            <!--                        <b-row>-->
            <!--                          <b-col class="d-flex">-->
            <!--                            <b-form-select-->
            <!--                              class="mr-75"-->
            <!--                              :options="[-->
            <!--                                { value: 'all', text: $t('therms.all') },-->
            <!--                                { value: 'with-trashed', text: $t('therms.with-trashed') },-->
            <!--                              ]"-->
            <!--                              style="border-radius: 0.6rem"-->
            <!--                              :placeholder="$t('therms.number-lastname-firstname')"-->
            <!--                            />-->
            <!--                            <touch-icon-button-->
            <!--                              style="min-width: 39px"-->
            <!--                              type="submit"-->
            <!--                            >-->
            <!--                              <feather-icon-->
            <!--                                icon="ChevronRightIcon"-->
            <!--                                size="18"-->
            <!--                                class="cursor-pointer"-->
            <!--                              />-->
            <!--                            </touch-icon-button>-->
            <!--                            <touch-icon-button-->
            <!--                              style="min-width: 39px"-->
            <!--                              color="danger"-->
            <!--                            >-->
            <!--                              <feather-icon-->
            <!--                                icon="XIcon"-->
            <!--                                size="18"-->
            <!--                                class="cursor-pointer"-->
            <!--                              />-->
            <!--                            </touch-icon-button>-->
            <!--                          </b-col>-->
            <!--                        </b-row>-->
            <!--                      </b-card>-->
            <!--                    </div>-->
            <!--                  </transition>-->

            <!--                </div>-->
            <!--              </transition>-->
            <!--            </div>-->

            <app-collapse
              type="border"
              class="animate__animated animate__fadeInUp"
            >
              <app-collapse-expedition-sheet :list="sortedList" />
            </app-collapse>
          </template>
          <template v-else>
            <div class="mt-3 text-center px-50">
              <span style="font-size: 6.5em">
                🚧
              </span>
              <h7 class="mt-1">
                {{ $t('therms.no-expedition-sheet') }}
              </h7>
              <p class="text-black-50 mt-0 pb-50">
                {{ $t('pages.expedition_sheets.now.no-data') }}
              </p>
              <div class="mb-2">
                <TouchButton
                  size="xs"
                  @action="$router.push({ name:ROUTE_NAME_NOW })"
                >
                  {{ $t('therms.go-back') }}
                </TouchButton>
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
  </scroller>
</template>

<script>
import NavButtonBar from '@core/layouts/components/app-navbar/NavButtonBar.vue'
import NavButton from '@core/layouts/components/app-navbar/NavButton.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import {
  BCard, BFormInput, BFormSelect, BSpinner,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import TouchButton from '@core/components/touch-button/TouchButton.vue'
// eslint-disable-next-line import/no-cycle
import { NAME_NOW } from '@/router/routes/now'
import AppCollapseExpeditionSheet from '@/views/components/AppCollapseExpeditionSheet.vue'
import TouchIconButton from '@core/components/touch-button/TouchIconButton.vue'

export default {
  components: {
    AppCollapseExpeditionSheet,
    TouchButton,
    TouchIconButton,
    BSpinner,
    NavButtonBar,
    NavButton,
    AppCollapse,
    BCard,
    BFormSelect,

  },
  data() {
    return {
      // ui
      error: false,
      displayOptions: false,
      displayFilters: false,
      loader: false,
    }
  },
  computed: {
    ...mapGetters({
      list: 'shipmentsNowExpeditionSheets/getList',
      has: 'shipmentsNowExpeditionSheets/has',
      count: 'shipmentsNowExpeditionSheets/count',
      isFetch: 'shipmentsNowExpeditionSheets/isFetch',
      lastPull: 'shipmentsNowExpeditionSheets/getLastPull',
      hasWithTrashed: 'shipmentsNowExpeditionSheets/hasWithTrashed',
      hasMultipleFarmers: 'farmers/hasMultipleFarmers',
    }),
    ROUTE_NAME_NOW() {
      return NAME_NOW
    },
    /**
     * @returns {string|null}
     */
    lastPullFormat() {
      if (!this.lastPull) return null
      return (`${this.lastPull?.format('LT')}`).toLowerCase()
    },
    sortedList() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.list
        .sort((a, b) => new Date(b.datetime) - new Date(a.datetime))
    },
  },
  watch: {
    displayOptions: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.displayFilters = false
        }
      },
    },
  },
  async mounted() {
    this.error = false

    this.emitter.on('appStateChange', async isActive => {
      if (this.needFetch(isActive)) await this.fetch(true)
    })

    try {
      if (this.needFetch(true)) await this.fetch(true)
    } catch (err) {
      this.error = true
      throw err
    }
  },
  beforeDestroy() {
    this.emitter.off('appStateChange')
  },
  methods: {
    needFetch(isActive = false) {
      if (this.$store.getters['shipmentsNowExpeditionSheets/getLastPull'] === null) return true

      return (isActive && (this.$store.getters['shipmentsNowExpeditionSheets/getLastPull']
        .locale('en')
        .format('YYYY-MM-DD') !== this.$moment()
        .locale('en')
        .format('YYYY-MM-DD')
          || this.$moment()
            .diff(this.$store.getters['shipmentsNowExpeditionSheets/getLastPull'], 'minutes') >= 5))
    },
    /**
     * @param {Boolean} force
     */
    async fetch(force = false) {
      if (force) {
        this.$store.commit('shipmentsNowExpeditionSheets/clear')
      }

      if (!this.$store.getters['shipmentsNowExpeditionSheets/isFetch']) {
        await this.$store.dispatch('shipmentsNowExpeditionSheets/fetch', true)
      }
    },
    /**
     * @param {Function} finishToRefresh
     * @param {Boolean} force
     * @returns {Promise<void>}
     */
    async refresh(finishToRefresh, force = false) {
      this.error = false

      try {
        if (force) this.$store.commit('shipmentsNowExpeditionSheets/clear')
        await this.$store.dispatch('shipmentsNowExpeditionSheets/fetch')
        finishToRefresh()
      } catch (err) {
        this.error = true
        finishToRefresh()

        throw err
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/base/bootstrap-extended/_include';
@import '@core/scss/base/components/_include';

table tr td:nth-child(2) {
  padding-left: 20px;
}

</style>
